module.exports = __webpack_public_path__ + "static/media/Beating Fanduel Daily Fantasy Baskteball.21a41777.pdf";